export default "__VITE_ASSET__C4uZ0Dmf__"